import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { loadScript } from "@paypal/paypal-js";
const paypalkey =
  "AX8-1gtF_LtGtWDeCNMGowWabtufbPL4X5sDmCYOnutILkCW1xTA_zqrSdCwrNb10KOD4HUI74ec3Dld";

const initialOptions = {
  "client-id": paypalkey,
  currency: "CAD",
  intent: "capture",
};

export const PayPalButtons = (props) => {
  const { createOrder, onApprove } = props;
  useEffect(() => {
    const paypalContainer = document.getElementById("paypal-container");
    const paypalbuttonscontainer = document.querySelector(
      '[id^="zoid-paypal-buttons-uid_"]'
    );
    if (paypalContainer && !paypalContainer.contains(paypalbuttonscontainer)) {
      loadScript({
        "client-id": paypalkey,
        currency: "CAD",
        intent: "authorize",
        "buyer-country": "CA",
      })
        .then((paypal) => {
          paypal
            .Buttons({
              createOrder: (data, actions) => {
                return createOrder(data, actions);
              },
              onApprove: (data, actions) => {
                return onApprove(data, actions);
              },
            })
            .render("#paypal-container")
            .catch((error) => {
              console.error("failed to render the PayPal Buttons", error);
            });
        })
        .catch((error) => {
          console.error("failed to load the PayPal JS SDK script", error);
        });
    }
  });
  return <></>;
};
